import React from 'react'
import { Row, Col } from 'rsuite'

export default function PanelHeader({ leftString = '', rightString = '' }) {
  return (
    <>
      <Row>
        <Col lg={12} md={12} sm={24} xs={24}>
          {leftString}
        </Col>
        <Col lg={12} md={12} sm={24} xs={24} style={{ textAlign: 'right' }}>
          {rightString}
        </Col>
      </Row>
    </>
  )
}
